import type { FaireAdCampaignEntity } from "../../entity_types/adCampaign";

export const campEuNew: FaireAdCampaignEntity = {
  token: "camp_eu_new",
  type: "adCampaign",
  advertiserProfileToken: "adv_eu_brand",
  segment: "NEW_MARKETPLACE",
  status: "RUNNING",
  monthlyBudgetDollars: 400,
  startedRunningAt: "2026-06-09",
  segmentMetrics: {
    numCustomersAcquired: 12,
    salesDollars: 1640,
    totalAdsSpendDollars: 635,
    cpaDollars: 52.96,
    bestEstimateSalesDollars: 2475,
    bestEstimateRoas: 3.89,
  },
  performancePeriodTokens: [],
  meta: {
    source: "snowflake",
    importedAt: "2026-10-12T00:00:00.000Z",
    importedBy: "real-brand-data",
  },
};
